/* eslint-disable react/no-string-refs */
/* eslint-disable no-lonely-if */
/* eslint-disable consistent-return */
import React, { PureComponent } from 'react';
import {
  Grid,
  Dropdown,
  Divider,
  Loader,
  Container,
  Icon,
  Button
} from 'semantic-ui-react';
import { toast, ToastContainer } from 'react-toastify';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import debounce from 'lodash/debounce';
import qs from 'qs';
import styled from 'styled-components';
import { getAds } from '../../fbApi/Ad';
import months from '../../utils/months';
import { getAccounts, refreshAccounts } from '../../services/AccountService';
import { getCampaigns, getCampaign } from '../../fbApi/Campaign';
import { clearFbCacheInLocalStorage } from '../../fbApi/fbCallManager';
import { updateUrlComparerV2 } from '../../utils/urls';
import {
  buildAdPreviewObjectCompare,
  sortAdsByFormatV2
} from '../../utils/ad.common';
import { retrieveAllAdsInfo, getUtms } from '../../services/AdServiceManager';
import TabContainerComponent from '../Flipper/ParentSection/TabContainerComponent';
import ProgressBarCompareAds from '../Flipper/ParentSection/ProgressBarCompareAds';
import AdPreviewLoader from '../../components/common/AdPreviewLoader';
import CampaignTagsContainer from './../Presentation/PresentationComponents/CampaignTagsContainer';
import * as AppActions from '../../actions';
import './AdComparer.css';

const ProcessingErrorText = styled.h3`
  text-align: center;
  padding-top: 100px;
`;

class AdComparer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      utms: {},
      activeIndex: 0,
      campaignKey: '',
      adElementId: '',
      accountOptions: null,
      showYearLoader: false,
      showYearSelector: false,
      showFirstMonthSelector: false,
      processTabs: false,
      showSecondMonthSelector: false,
      processing: true,
      message: '',
      campaignName: {
        PRODUCT_CATALOG_SALES: null,
        LEAD_GENERATION: null,
        VIDEO_VIEWS: null,
        LINK_CLICKS: null,
        CONVERSIONS: null
      },
      campaignMonth: {
        PRODUCT_CATALOG_SALES: [],
        LEAD_GENERATION: [],
        VIDEO_VIEWS: [],
        LINK_CLICKS: [],
        CONVERSIONS: []
      },
      token: props.getFbToken(),
      qcProcessed: false,
      tabs: null,
      qcInfo: null,
      loaderInterval: null,
      loaderCount: 0,
      loaderTotal: 0,
      hasAccount: false,
      error: false,
      sorting: 'type',
      campaignTagsObjectsFirstMonth: [],
      campaignTagsObjectsSecondMonth: [],
      refreshAccountsLoading: false
    };
  }

  componentDidMount() {
    this.loadUtms();
    const { setSectionTitle, saveGTMEvent } = this.props;
    setSectionTitle('Ad Comparer');
    saveGTMEvent('Ad Comparer', 'Ad Comparer');
    this.getAdAccounts().then(() => {
      this.preSelectFields().then(() => {
        this.setState({ processing: false }, () => {
          this.expandAllAdsOnMount();
        });
      });
    });
    document
      .querySelector('.App-content')
      .addEventListener('scroll', debounce(this.handleScroll, 300));
  }

  expandAllAdsOnMount = () => {
    const url = window.location.href;
    const urlParts = url.split('#');

    if (!urlParts[1]) {
      return;
    }

    const params = urlParts[1].split('&');
    const showAllParam = _.find(
      params,
      (p) => p && p.indexOf('showAll=') !== -1
    );
    if (showAllParam) {
      const showAllValue = showAllParam
        .split('=')[1]
        .replace(new RegExp('%20', 'g'), ' ');
      const noExpand = !showAllValue || showAllValue === 'false';
      if (!noExpand) {
        this.props.actions.expandAll();
      }
    }
  };

  refreshAccounts = () => {
    clearFbCacheInLocalStorage();
    this.setState(
      (prevState) => ({
        ...prevState,
        refreshAccountsLoading: true
      }),
      async () => {
        await this.refreshAdAccounts();
        await this.preSelectFields();
        this.setState((...prevState) => ({
          ...prevState,
          processing: false,
          refreshAccountsLoading: false
        }));
      }
    );
  };

  loadUtms = async () => {
    const response = await getUtms();
    const utms = {};
    response.data.utms.map((utm) => {
      utms[utm.name] = utm;
      return null;
    });
    this.setState({ utms });
  };

  handleScroll = () => {
    if (this.props.expandAll) {
      const hashUrl = window.location.hash.replace('#', '');
      const params = qs.parse(hashUrl);

      const urlParams = {
        ...params,
        ad: '',
        campaign: ''
      };

      for (const item of document.querySelectorAll(
        '.active.tab .accordion-item'
      )) {
        const rect = item.getBoundingClientRect();
        const offsetHeight = (item.offsetHeight - 20) * -1;

        if (rect.top > offsetHeight && rect.top <= 85) {
          const parts = item.getAttribute('id').split('-');
          urlParams.ad = parts[1];
          urlParams.campaign = parts[2];
          if (!params.ad || params.ad !== urlParams.ad) {
            updateUrlComparerV2(urlParams);
            break;
          }
        }
      }
      const appScrollTop = document.querySelector('.App-content').scrollTop;

      if (appScrollTop <= 1) {
        urlParams.ad = '';
        urlParams.campaign = '';
        updateUrlComparerV2(urlParams);
      }
    }
  };

  preSelectFields = async () => {
    const hashUrl = window.location.hash.replace('#', '');
    const params = qs.parse(hashUrl);

    const selectedAccount = params.account;

    if (selectedAccount) {
      const account = _.find(
        this.state.accounts,
        (a) => a.name && a.name.indexOf(selectedAccount) !== -1
      );

      if (account) {
        this.setState({ hasAccount: true });
        this.selectAccount(account.account_id, account.name).then(() => {
          if (params.yearFirst) {
            const filteredCampaigns = this.state.campaigns.filter(
              (val) => val.year === params.yearFirst
            );
            this.selectYear(params.yearFirst, 'First');
            if (params.monthFirst) {
              const month = _.find(
                filteredCampaigns,
                (c) => c.text && c.text === params.monthFirst
              );
              this.selectMonth(month.value, 'First', params.monthFirst);
            }
          }
          if (params.yearSecond) {
            const filteredCampaigns = this.state.campaigns.filter(
              (val) => val.year === params.yearSecond
            );
            this.selectYear(params.yearSecond, 'Second');
            if (params.monthSecond) {
              const month = _.find(
                filteredCampaigns,
                (c) => c.text && c.text === params.monthSecond
              );
              this.selectMonth(month.value, 'Second', params.monthSecond);
            }
          }

          const accordionIndex = params.ad;
          const campaignKey = params.campaign;

          if (campaignKey && accordionIndex) {
            this.props.actions.adPreviewAdAccordionIndex(
              parseInt(accordionIndex, 10),
              campaignKey
            );
            this.setState(
              {
                adElementId: `#accordion-${accordionIndex}-${campaignKey}`,
                campaignKey
              },
              () => {
                this.updateUrlByAccordion(accordionIndex, campaignKey);
              }
            );
          }
        });
      }
    }
  };

  onAccountSelect = (event, data) => {
    const account = _.find(
      data.options,
      (option) => option.value === data.value
    );

    const accountId = account.value;
    const accountName = account.text;

    this.selectAccount(accountId, accountName);
  };

  selectAccount = async (accountId, accountName) => {
    const hashUrl = window.location.hash.replace('#', '');
    const urlParams = qs.parse(hashUrl);
    urlParams.account = accountName;
    urlParams.ad = '';
    urlParams.campaign = '';
    updateUrlComparerV2(urlParams);
    const utmsWithAccountsFiltered = this.filterUtms(accountId);
    this.setState({
      utms: utmsWithAccountsFiltered,
      showTabs: false,
      showFirstMonthSelector: false,
      showSecondMonthSelector: false,
      selectedFirstYear: '',
      selectedSecondYear: '',
      adAccountId: accountId,
      adAccountName: accountName,
      selectedFirstMonth: '',
      selectedSecondMonth: '',
      adsToCompareFirst: [],
      adsToCompareSecond: [],
      allAdsInfoFirst: [],
      allAdsInfoSecond: [],
      processTabs: false
    });

    await this.getCampaigns(accountId);
  };

  filterUtms = (accountId) => {
    const { utms } = this.state;
    const utmKeys = Object.keys(utms);
    const filteredUtms = {};

    utmKeys.forEach((key) => {
      const currentUtm = utms[key];
      const { accounts } = currentUtm;
      let includeUtm = !accounts || accounts.length <= 0;
      if (accounts.length > 0) {
        const foundAccountIndex = accounts.findIndex((accountObj) => {
          const { accountId: currentId } = accountObj;
          return currentId === accountId;
        });
        includeUtm = foundAccountIndex !== -1;
      }
      if (includeUtm) filteredUtms[key] = currentUtm;
    });
    return filteredUtms;
  };

  onYearSelect = (event, data) => {
    const value = data.value;
    const selector = data.id === 'FirstYearSelector' ? 'First' : 'Second';

    this.selectYear(value, selector);
  };

  selectYear = (year, selector) => {
    const hashUrl = window.location.hash.replace('#', '');
    const urlParams = qs.parse(hashUrl);
    urlParams[`year${selector}`] = year;
    updateUrlComparerV2(urlParams);
    urlParams.ad = '';
    urlParams.campaign = '';
    const filteredCampaigns = this.state.campaigns.filter(
      (val) => val.year === year
    );

    this.setState({
      [`show${selector}MonthSelector`]: true,
      [`show${selector}MonthLoader`]: false,
      [`selected${selector}Year`]: year,
      [`${selector}Months`]: filteredCampaigns,
      [`selected${selector}Months`]: '',
      processTabs: false
    });
  };

  onMonthSelect = async (event, data) => {
    const value = data.value;
    const selector = data.id === 'FirstMonthSelector' ? 'First' : 'Second';

    const n = _.find(data.options, (o) => o.value === data.value);
    this.selectMonth(value, selector, n.text);
  };

  selectMonth = (month, selector, monthText) => {
    const hashUrl = window.location.hash.replace('#', '');
    const urlParams = qs.parse(hashUrl);
    urlParams[`month${selector}`] = monthText;
    urlParams.ad = '';
    urlParams.campaign = '';
    updateUrlComparerV2(urlParams);

    const campaignData = this.state.data;

    const campaignTagsObjects = [];

    campaignData.forEach((campaign) => {
      if (campaign.adlabels && campaign.name.includes(monthText)) {
        const campaignTagsObject = {
          campaignId: campaign.id,
          campaignName: campaign.name,
          campaignObjective: campaign.objective,
          campaignTags: campaign.adlabels
        };
        campaignTagsObjects.push(campaignTagsObject);
      }
    });

    this.setState(
      () => ({
        [`selected${selector}Month`]: month,
        [`campaignTagsObjects${selector}Month`]: campaignTagsObjects
      }),
      () => {
        this.getAdsToCompare();
      }
    );
  };

  handleTabChange = (e, data) => {
    const hashUrl = window.location.hash.replace('#', '');
    const params = qs.parse(hashUrl);
    updateUrlComparerV2({
      ...params,
      ad: '',
      campaign: data.panes[data.activeIndex].campaignKey
    });
    if (this.refs.campaignTagsContainerFirst) {
      this.refs.campaignTagsContainerFirst.setCurrentCampaignForTable();
    }
    if (this.refs.campaignTagsContainerSecond) {
      this.refs.campaignTagsContainerSecond.setCurrentCampaignForTable();
    }
  };

  updateUrlByAccordion = (ad, campaignKey) => {
    const hashUrl = window.location.hash.replace('#', '');
    const params = qs.parse(hashUrl);

    updateUrlComparerV2({
      ...params,
      ad,
      campaign: campaignKey
    });

    this.scrollToAccordion(`#accordion-${ad}-${campaignKey}`);
  };

  scrollToAccordion = (id) => {
    if (document.querySelector(id)) {
      document.querySelector(id).scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      });
    }
  };

  getCampaigns = async (id) => {
    try {
      this.setState({
        campaigns: [],
        showYearLoader: true
      });

      await this.queryCampaigns(id);

      this.setState({
        campaigns: this.state.selectedCampaigns,
        showYearSelector: true,
        showYearLoader: false
      });
    } catch (error) {
      console.log(error);
    }
  };

  getAds = async (ids, selection) => {
    this.setState({
      campaignIds: ids,
      showAdsLoading: true
    });
    const { token, campaignName } = this.state;
    const allCampaigns = await Promise.all(
      _.map(ids, async (id) => {
        const campaign = await getCampaign(id, token);

        const campaignObjective = campaign.objective;
        const cn = campaignName;
        cn[campaignObjective] = campaign.name.replace(/_/g, ' ');
        this.setState({
          campaignName: cn
        });
        const resultAds = await getAds(campaign.id, token);
        const ads = resultAds.data;

        const previewObjects = ads.map(async (ad) => ({
          ...ad,
          campaignObjective
        }));

        let loaderTotal = this.state.loaderTotal;
        this.setState({ loaderTotal: (loaderTotal += ads.length) });
        return Promise.all(previewObjects);
      })
    );

    const ccm = {
      PRODUCT_CATALOG_SALES: [],
      LEAD_GENERATION: [],
      VIDEO_VIEWS: [],
      LINK_CLICKS: [],
      CONVERSIONS: []
    };

    const qcProcess = {
      LINK_CLICKS: {
        totalAds: 0,
        totalQC: 0
      },
      VIDEO_VIEWS: {
        totalAds: 0,
        totalQC: 0
      },
      LEAD_GENERATION: {
        totalAds: 0,
        totalQC: 0
      },
      PRODUCT_CATALOG_SALES: {
        totalAds: 0,
        totalQC: 0
      },
      CONVERSIONS: {
        totalAds: 0,
        totalQC: 0
      }
    };
    _.forEach(allCampaigns, (c) => {
      if (c[0] && ccm[c[0].campaignObjective]) {
        ccm[c[0].campaignObjective] = ccm[c[0].campaignObjective].concat(c);
        qcProcess[c[0].campaignObjective].totalAds =
          ccm[c[0].campaignObjective].length;
      }
    });

    const allIds = [];

    Object.keys(ccm).forEach((o) => {
      ccm[o].forEach((ad) => allIds.push(ad.id));
    });
    const allAdsInfo = await retrieveAllAdsInfo(allIds.join(','));

    allAdsInfo.ads.forEach(() => {
      let loaderCount = this.state.loaderCount;
      loaderCount += 1;
      this.setState({ loaderCount });
    });

    this.props.actions.initCompareTotalAds(qcProcess, selection);

    this.setState({
      [`adsToCompare${selection}`]: ccm,
      [`allAdsInfo${selection}`]: allAdsInfo,
      [`initQCProcess${selection}`]: qcProcess
    });
  };

  getAdsToCompare = async () => {
    const { selectedFirstMonth, selectedSecondMonth, loaderCount } = this.state;
    if (selectedFirstMonth && selectedSecondMonth) {
      this.setState({
        processing: true,
        // message: 'Comparing...',
        showTabs: false,
        processTabs: false,
        qcProcessed: false,
        tabs: null
      });
      const idsFirst = selectedFirstMonth.split(',');
      const idsSecond = selectedSecondMonth.split(',');
      await this.getAds(idsFirst, 'First');
      await this.getAds(idsSecond, 'Second');
      this.setState({
        processTabs: true
      });
    } else {
      if (!this.state.hasAccount) {
        const idsFirst = selectedFirstMonth.split(',');
        this.setState({ processing: true }, () => {
          const loaderInterval = setInterval(() => {
            this.setState({
              loaderCount: loaderCount + 1,
              loaderTotal: idsFirst.length
            });
          }, 500);
          this.setState({ loaderInterval });
          setTimeout(() => {
            clearInterval(this.state.loaderInterval);
            this.setState({
              processing: false,
              loaderInterval: null,
              loaderCount: 0,
              loaderTotal: 0
            });
          }, idsFirst.length * 500);
        });
      }
    }
  };

  getAdAccounts = async () => {
    try {
      const result = await getAccounts();

      const accountOptions = _.sortBy(
        _.map(result, (op, index) => ({
          key: index,
          value: op.account_id,
          text: op.name
        })),
        'text'
      );

      this.setState({
        data: result,
        accounts: _.sortBy([...result], 'name'),
        accountOptions
      });
    } catch (error) {
      console.log(error);
    }
  };

  refreshAdAccounts = async () => {
    try {
      const result = await refreshAccounts();

      const accountOptions = _.sortBy(
        _.map(result, (op, index) => ({
          key: index,
          value: op.account_id,
          text: op.name
        })),
        'text'
      );

      this.setState({
        data: result,
        accounts: _.sortBy([...result], 'name'),
        accountOptions
      });
    } catch (error) {
      console.log(error);
    }
  };

  queryCampaigns = async (id) => {
    const screen = 'Ad Comparer';
    const campaigns = await getCampaigns(id, this.state.token, screen);
    const result = campaigns.data;

    const assocCampaigns = [];
    const campaignMonths = [];
    const years = [];

    _.map(_.reverse(_.sortBy([...result], 'start_time')), (campaign) => {
      const firstPart = campaign.name.split('_')[0];
      const year =
        firstPart.length === 4
          ? firstPart
          : firstPart.substring(firstPart.length - 4, firstPart.length);
      const month =
        firstPart.length === 4
          ? campaign.name.split('_')[1]
          : firstPart.substring(0, firstPart.length - 4);
      assocCampaigns[year + month] = {
        month_year: null,
        ids: []
      };
    });
    _.map(_.reverse(_.sortBy([...result], 'start_time')), (campaign) => {
      const firstPart = campaign.name.split('_')[0];
      const year =
        firstPart.length === 4
          ? firstPart
          : firstPart.substring(firstPart.length - 4, firstPart.length);
      const month =
        firstPart.length === 4
          ? campaign.name.split('_')[1]
          : firstPart.substring(0, firstPart.length - 4);

      const existentYear = years.filter((item) => item.text === year);

      if (existentYear.length === 0) {
        years.push({
          value: year,
          text: year
        });
      }

      assocCampaigns[year + month].month = month;
      assocCampaigns[year + month].year = year;
      assocCampaigns[year + month].ids.push(campaign.id);
    });

    _.mapKeys(assocCampaigns, (month) => {
      if (month) {
        campaignMonths.push(month);
      }
    });

    const campaignOptions = _.map(campaignMonths, (op, index) => {
      const month = months.filter((item) => item.shortName === op.month);

      return {
        key: index,
        value: op.ids.join(','),
        text: month[0] ? month[0].monthName : op.month,
        accountId: id,
        year: op.year
      };
    });

    const monthsOpt = _.map(campaignOptions, (op) => ({
      value: op.text,
      text: op.text,
      campaignsIds: op.value
    }));

    this.setState({
      selectedCampaigns: campaignOptions,
      data: result,
      years,
      months: monthsOpt
    });
  };

  processAdsAsync = async (compareAdsFirst, compareAdsSecond) => {
    try {
      const { allAdsInfoFirst, token, allAdsInfoSecond } = this.state;
      const firstAds = await Promise.all(
        _.map(compareAdsFirst, async (ad) => {
          const adData = allAdsInfoFirst.ads.find((a) => a.adId === ad.id);
          const buildAd = {
            ...ad,
            adData: adData ? adData.adData : undefined
          };
          const adPreview = await buildAdPreviewObjectCompare(
            buildAd,
            'First',
            token
          );
          return adPreview;
        })
      );
      const secondAds = await Promise.all(
        _.map(compareAdsSecond, async (ad) => {
          const adData = allAdsInfoSecond.ads.find((a) => a.adId === ad.id);
          const buildAd = {
            ...ad,
            adData: adData ? adData.adData : undefined
          };
          const adPreview = await buildAdPreviewObjectCompare(
            buildAd,
            'Second',
            token
          );
          return adPreview;
        })
      );
      return {
        firstAds,
        secondAds
      };
    } catch (e) {
      console.log(e);
    }
  };

  getHoldsAndComments = () => {
    const { allAdsInfoFirst, allAdsInfoSecond } = this.state;
    const qcInfo = {
      holdsFirst: 0,
      commentsFirst: 0,
      holdsSecond: 0,
      commentsSecond: 0
    };

    allAdsInfoFirst.ads.forEach((ad) => {
      if (ad.adData.adQc && ad.adData.adQc.on_hold) {
        qcInfo.holdsFirst += 1;
      }

      const note = ad.adData.adNotes.find((n) => n.note_qc);
      if (note) {
        qcInfo.commentsFirst += 1;
      }
    });

    allAdsInfoSecond.ads.forEach((ad) => {
      if (ad.adData.adQc && ad.adData.adQc.on_hold) {
        qcInfo.holdsSecond += 1;
      }

      const note = ad.adData.adNotes.find((n) => n.note_qc);
      if (note) {
        qcInfo.commentsSecond += 1;
      }
    });

    return qcInfo;
  };

  initializeTabs = async () => {
    const errors = [];
    const { qcProcessed, adsToCompareFirst, adsToCompareSecond } = this.state;
    const { actions } = this.props;
    const stateTabs = this.state.tabs;
    const qcInfo = this.getHoldsAndComments();

    if (qcProcessed) return null;

    if (stateTabs === null) {
      const tabs = [];
      let adsToProcessFirstQC = [];
      let adsToProcessSecondQC = [];
      if (
        adsToCompareFirst.LINK_CLICKS.length > 0 ||
        adsToCompareSecond.LINK_CLICKS.length > 0
      ) {
        const processedAds = await this.processAdsAsync(
          adsToCompareFirst.LINK_CLICKS,
          adsToCompareSecond.LINK_CLICKS,
          'LINK_CLICKS'
        );
        if (processedAds) {
          const ads = sortAdsByFormatV2(
            processedAds.firstAds,
            processedAds.secondAds
          );
          tabs.push({
            menuItem: 'Traffic Ads',
            ads,
            tabKey: 'LINK_CLICKS'
          });
          adsToProcessFirstQC = adsToProcessFirstQC.concat(
            processedAds.firstAds
          );
          adsToProcessSecondQC = adsToProcessSecondQC.concat(
            processedAds.secondAds
          );
        } else {
          errors.push('LINK_CLICKS');
        }
      }
      if (
        adsToCompareFirst.LEAD_GENERATION.length > 0 ||
        adsToCompareSecond.LEAD_GENERATION.length > 0
      ) {
        const processedAds = await this.processAdsAsync(
          adsToCompareFirst.LEAD_GENERATION,
          adsToCompareSecond.LEAD_GENERATION,
          'LEAD_GENERATION'
        );
        if (processedAds) {
          const ads = sortAdsByFormatV2(
            processedAds.firstAds,
            processedAds.secondAds
          );
          tabs.push({
            menuItem: 'Lead Ads',
            ads,
            tabKey: 'LEAD_GENERATION'
          });
          adsToProcessFirstQC = adsToProcessFirstQC.concat(
            processedAds.firstAds
          );
          adsToProcessSecondQC = adsToProcessSecondQC.concat(
            processedAds.secondAds
          );
        } else {
          errors.push('LEAD_GENERATION');
        }
      }

      if (
        adsToCompareFirst.VIDEO_VIEWS.length > 0 ||
        adsToCompareSecond.VIDEO_VIEWS.length > 0
      ) {
        const processedAds = await this.processAdsAsync(
          adsToCompareFirst.VIDEO_VIEWS,
          adsToCompareSecond.VIDEO_VIEWS,
          'VIDEO_VIEWS'
        );
        if (processedAds) {
          const ads = sortAdsByFormatV2(
            processedAds.firstAds,
            processedAds.secondAds
          );
          tabs.push({
            menuItem: 'Video Ads',
            ads,
            tabKey: 'VIDEO_VIEWS'
          });
          adsToProcessFirstQC = adsToProcessFirstQC.concat(
            processedAds.firstAds
          );
          adsToProcessSecondQC = adsToProcessSecondQC.concat(
            processedAds.secondAds
          );
        } else {
          errors.push('VIDEO_VIEWS');
        }
      }

      if (
        adsToCompareFirst.PRODUCT_CATALOG_SALES.length > 0 ||
        adsToCompareSecond.PRODUCT_CATALOG_SALES.length > 0
      ) {
        const processedAds = await this.processAdsAsync(
          adsToCompareFirst.PRODUCT_CATALOG_SALES,
          adsToCompareSecond.PRODUCT_CATALOG_SALES,
          'PRODUCT_CATALOG_SALES'
        );
        if (processedAds) {
          const ads = sortAdsByFormatV2(
            processedAds.firstAds,
            processedAds.secondAds
          );
          tabs.push({
            menuItem: 'Dynamic Ads',
            ads,
            tabKey: 'PRODUCT_CATALOG_SALES'
          });
          adsToProcessFirstQC = adsToProcessFirstQC.concat(
            processedAds.firstAds
          );
          adsToProcessSecondQC = adsToProcessSecondQC.concat(
            processedAds.secondAds
          );
        } else {
          errors.push('PRODUCT_CATALOG_SALES');
        }
      }

      if (
        adsToCompareFirst.CONVERSIONS.length > 0 ||
        adsToCompareSecond.CONVERSIONS.length > 0
      ) {
        const processedAds = await this.processAdsAsync(
          adsToCompareFirst.CONVERSIONS,
          adsToCompareSecond.CONVERSIONS,
          'CONVERSIONS'
        );
        if (processedAds) {
          const ads = sortAdsByFormatV2(
            processedAds.firstAds,
            processedAds.secondAds
          );
          tabs.push({
            menuItem: 'Site Visits',
            ads,
            tabKey: 'CONVERSIONS'
          });
          adsToProcessFirstQC = adsToProcessFirstQC.concat(
            processedAds.firstAds
          );
          adsToProcessSecondQC = adsToProcessSecondQC.concat(
            processedAds.secondAds
          );
        } else {
          errors.push('CONVERSIONS');
        }
      }

      if (errors.length === 0) {
        adsToProcessFirstQC.forEach((adPreview) => {
          if (adPreview.adQc && adPreview.adQc !== null) {
            if (adPreview.adQc.qc2) {
              const qcAdsProgress = this.state.initQCProcessFirst;
              qcAdsProgress[adPreview.campaignObjective].totalQC =
                qcAdsProgress[adPreview.campaignObjective].totalQC + 1;
              let totalAds = 0;
              let totalQC = 0;
              Object.keys(qcAdsProgress).forEach((key) => {
                totalAds += qcAdsProgress[key].totalAds;
                totalQC += qcAdsProgress[key].totalQC;
              });
              const generalQCProgress = (totalQC * 100) / totalAds;
              actions.updateCompareTotalQCAds(
                qcAdsProgress,
                generalQCProgress,
                'First'
              );
            }
          }
        });

        adsToProcessSecondQC.forEach((adPreview) => {
          if (adPreview.adQc && adPreview.adQc !== null) {
            if (adPreview.adQc.qc2) {
              const qcAdsProgress = this.state.initQCProcessSecond;
              qcAdsProgress[adPreview.campaignObjective].totalQC =
                qcAdsProgress[adPreview.campaignObjective].totalQC + 1;
              let totalAds = 0;
              let totalQC = 0;
              Object.keys(qcAdsProgress).forEach((key) => {
                totalAds += qcAdsProgress[key].totalAds;
                totalQC += qcAdsProgress[key].totalQC;
              });
              const generalQCProgress = (totalQC * 100) / totalAds;
              actions.updateCompareTotalQCAds(
                qcAdsProgress,
                generalQCProgress,
                'Second'
              );
            }
          }
        });

        const tabIndex = tabs.map((tab) => tab.tabKey);
        let activeIndex = 0;

        if (this.state.campaignKey !== '')
          activeIndex = tabIndex.indexOf(this.state.campaignKey);

        this.setState({
          tabs,
          processing: false,
          message: '',
          showTabs: true,
          qcProcessed: true,
          qcInfo,
          activeIndex
        });
      } else {
        this.setState({ error: true }, () => {
          this.setState({ processing: false, showTabs: true });
        });
      }
    }
  };

  renderTabs = () => {
    const {
      error,
      showTabs,
      tabs,
      adsToCompareFirst,
      adsToCompareSecond,
      sorting,
      activeIndex,
      utms,
      adAccountName
    } = this.state;

    const { getFbToken } = this.props;

    if (error) {
      return (
        <ProcessingErrorText>
          There was an issue loading up the Ads from Facebook. Please try again
          later.
        </ProcessingErrorText>
      );
    }

    if (showTabs && tabs && adsToCompareFirst && adsToCompareSecond) {
      return (
        <div>
          <TabContainerComponent
            tabs={tabs}
            sorting={sorting}
            getFbToken={getFbToken}
            activeIndex={activeIndex}
            handleTabChange={this.handleTabChange}
            utms={utms}
            adAccountName={adAccountName}
          />
        </div>
      );
    }
    return null;
  };

  renderYear = (source) => {
    const { showYearSelector, processing, years, showYearLoader } = this.state;
    if (showYearSelector) {
      return (
        <Dropdown
          disabled={processing}
          placeholder="Year"
          id={`${source}YearSelector`}
          search
          selection
          value={this.state[`selected${source}Year`]}
          options={years}
          onChange={this.onYearSelect}
        />
      );
    } else if (showYearLoader) {
      return (
        <Container>
          <Loader inline className="active" />
        </Container>
      );
    }
    return null;
  };

  renderMonth = (source) => {
    const { processing } = this.state;
    if (this.state[`show${source}MonthSelector`]) {
      return (
        <div>
          <Dropdown
            disabled={processing}
            placeholder="Month"
            id={`${source}MonthSelector`}
            search
            selection
            value={this.state[`selected${source}Month`]}
            options={this.state[`${source}Months`]}
            onChange={this.onMonthSelect}
          />
        </div>
      );
    } else if (this.state[`show${source}MonthLoader`]) {
      return (
        <Container>
          <Loader inline className="active" />
        </Container>
      );
    }
    return null;
  };

  renderProgressBar = (source) => {
    const {
      showTabs,
      tabs,
      adsToCompareFirst,
      adsToCompareSecond
    } = this.state;
    if (showTabs && tabs && adsToCompareFirst && adsToCompareSecond) {
      const classnames = ['progress-container'];
      if (source === 'First') {
        classnames.push('left');
      } else {
        classnames.push('right');
      }
      return (
        <ProgressBarCompareAds className={classnames} keySection={source} />
      );
    }
    return null;
  };

  renderQCInfo = (source) => {
    const {
      showTabs,
      tabs,
      adsToCompareFirst,
      adsToCompareSecond
    } = this.state;
    if (showTabs && tabs && adsToCompareFirst && adsToCompareSecond) {
      const qcInfo = this.state.qcInfo;
      if (!qcInfo) {
        return null;
      }

      if (source === 'First') {
        return (
          <div className="comparer-qc-info-first">
            <Icon size="large" name="comments outline" /> {qcInfo.commentsFirst}
            <Divider hidden />
            <Icon
              size="large"
              className="comparer-qc-info-warning"
              name="warning sign"
            />{' '}
            {qcInfo.holdsFirst}
          </div>
        );
      }
      return (
        <div className="comparer-qc-info-second">
          <Icon size="large" name="comments outline" /> {qcInfo.commentsSecond}
          <Divider hidden />
          <Icon
            size="large"
            className="comparer-qc-info-warning"
            name="warning sign"
          />{' '}
          {qcInfo.holdsSecond}
        </div>
      );
    }
    return null;
  };

  setSortingState = (newSortingCriteria) => {
    const { sorting } = this.state;
    if (sorting !== newSortingCriteria) {
      this.setState({ sorting: newSortingCriteria });
      toast(`Ads sorted by ${newSortingCriteria}`, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      });
    }
  };

  render() {
    const {
      processTabs,
      showTabs,
      processing,
      adAccountId,
      accountOptions,
      loaderCount,
      loaderTotal,
      message,
      campaignTagsObjectsFirstMonth,
      campaignTagsObjectsSecondMonth,
      selectedFirstMonth,
      selectedSecondMonth,
      refreshAccountsLoading
    } = this.state;

    if (processTabs && !showTabs) {
      this.initializeTabs();
    }
    return (
      <div className="page-container">
        <div className="container">
          <Grid>
            <Grid.Row columns={1}>
              <Grid.Column>
                <Dropdown
                  disabled={processing}
                  placeholder="Ad Accounts"
                  search
                  selection
                  value={adAccountId}
                  options={accountOptions}
                  onChange={this.onAccountSelect}
                />
                <Button
                  basic
                  compact
                  loading={refreshAccountsLoading}
                  color="blue"
                  icon="refresh"
                  onClick={this.refreshAccounts}
                  style={{ marginLeft: '1%' }}
                />
              </Grid.Column>
            </Grid.Row>
            <Divider />
            <Grid.Row columns={2}>
              <Grid.Column>
                {this.renderYear('First')}
                <Divider hidden />
                {this.renderMonth('First')}
                <Divider hidden />
                {this.renderProgressBar('First')}
                <Divider hidden />
                {this.renderQCInfo('First')}
              </Grid.Column>
              <Grid.Column>
                {this.renderYear('Second')}
                <Divider hidden />
                {this.renderMonth('Second')}
                <Divider hidden />
                {this.renderProgressBar('Second')}
                <Divider hidden />
                {this.renderQCInfo('Second')}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={2}>
              {selectedFirstMonth ? (
                <Grid.Column>
                  <CampaignTagsContainer
                    ref={'campaignTagsContainerFirst'}
                    campaignTagsObjects={campaignTagsObjectsFirstMonth}
                    screen={'comparer'}
                  />
                </Grid.Column>
              ) : null}
              {selectedSecondMonth ? (
                <Grid.Column>
                  <CampaignTagsContainer
                    ref={'campaignTagsContainerSecond'}
                    campaignTagsObjects={campaignTagsObjectsSecondMonth}
                    screen={'comparer'}
                  />
                </Grid.Column>
              ) : null}
            </Grid.Row>
          </Grid>
          <ToastContainer />
          <Divider hidden />
          {processing ? (
            <AdPreviewLoader
              loaderCount={loaderCount}
              loaderTotal={loaderTotal}
              color="grey"
              size="tiny"
            />
          ) : null}
          <span className="processing-message">{message}</span>
          {this.renderTabs()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  expandAll: state.adPreview.expandAllAds
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdComparer);



// WEBPACK FOOTER //
// ./src/screens/AdComparerV2/AdComparer.js